import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Modal from '../../../common/Modal';
import SelectInput from '../../../common/SelectInput';

const AddTimeTrackingEntry = ({
  on,
  closeModal,
  isOn,
  startedAtHours,
  startedAtMinutes,
  endedAtHours,
  endedAtMinutes,
  onStartedAtHoursChange,
  onStartedAtMinutesChange,
  onEndedAtHoursChange,
  onEndedAtMinutesChange,
  onSubmit,
  handleSubmit,
  valid,
  isSameTimezoneWithUser,
  shopTime,
  role,
  extendedHourlyWages,
  requirePasscode,
  onRoleChange,
  passcode,
  onPasscodeChange,
  allowedTimeTrackRoles,
  canEditTimeTracking,
}) => (
  <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-end">
    <button
      className="c-btn c-btn--primary c-btn--small u-mt"
      type="button"
      onClick={on}
      disabled={!canEditTimeTracking}
    >
      Add time
    </button>
    <span className="c-label-new u-ml" display-if={!isSameTimezoneWithUser}>
      Shop time: {shopTime}
    </span>
    <Modal
      title="Add time track"
      display-if={isOn}
      close={closeModal}
      showCloseButton
      className="u-min-width-280 u-max-width-430"
    >
      <form onSubmit={handleSubmit}>
        <div className="u-pv u-ph+ u-margin-auto">
          <div className="layout layout--middle">
            <div className="layout__item u-2/5">
              <div className="c-label">Started at</div>
            </div>
            <div className="layout__item u-1/10">
              <input
                className="c-input c-input--dashed c-input__no-shadow"
                type="number"
                value={startedAtHours}
                onChange={onStartedAtHoursChange}
              />
            </div>
            <div className="layout__item u-1/5">
              <div className="c-label u-type--lowercase">hh</div>
            </div>
            <div className="layout__item u-1/10">
              <input
                className="c-input c-input--dashed c-input__no-shadow"
                type="number"
                value={startedAtMinutes}
                onChange={onStartedAtMinutesChange}
              />
            </div>
            <div className="layout__item u-1/5">
              <div className="c-label u-type--lowercase">mm</div>
            </div>
            <div className="layout__item u-2/5">
              <div className="c-label">Ended at</div>
            </div>
            <div className="layout__item u-1/10">
              <input
                className="c-input c-input--dashed c-input__no-shadow"
                type="number"
                value={endedAtHours}
                onChange={onEndedAtHoursChange}
              />
            </div>
            <div className="layout__item u-1/5">
              <div className="c-label u-type--lowercase">hh</div>
            </div>
            <div className="layout__item u-1/10">
              <input
                className="c-input c-input--dashed c-input__no-shadow"
                type="number"
                value={endedAtMinutes}
                onChange={onEndedAtMinutesChange}
              />
            </div>
            <div className="layout__item u-1/5">
              <div className="c-label u-type--lowercase">mm</div>
            </div>

            {!!extendedHourlyWages &&
              <Fragment>
                <div className="layout__item u-2/5">
                  <div className="c-label">Role</div>
                </div>
                <div className="layout__item u-3/5">
                  <SelectInput
                    name="role"
                    className="c-select"
                    options={allowedTimeTrackRoles}
                    input={{
                      onChange: onRoleChange,
                      value: role,
                    }}
                  />
                </div>
              </Fragment>
            }


            {!!requirePasscode &&
              <Fragment>
                <div className="layout__item u-2/5">
                  <div className="c-label">Passcode</div>
                </div>
                <div className="layout__item u-3/5">
                  <input
                    className="c-input c-masked-input"
                    type="number"
                    inputMode="tel"
                    autoComplete="off"
                    value={passcode}
                    onChange={onPasscodeChange}
                  />
                </div>
              </Fragment>
            }
          </div>
        </div>
        <div className="c-label-new u-ml u-text-center" display-if={!isSameTimezoneWithUser}>
          Shop time: {shopTime}
        </div>
        <div className="u-p u-mb+ u-mt">
          <button
            onClick={closeModal}
            type="button"
            className="c-btn c-btn--default c-btn--small u-ph+ u-float-left"
          >
            cancel
          </button>
          <button
            onClick={onSubmit}
            type="submit"
            className="c-btn c-btn--primary c-btn--small u-float-right u-ph+"
            disabled={!valid}
          >
            Save
          </button>
        </div>
      </form>
    </Modal>
  </div>
);

AddTimeTrackingEntry.propTypes = {
  on: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  startedAtHours: PropTypes.number.isRequired,
  startedAtMinutes: PropTypes.number.isRequired,
  endedAtHours: PropTypes.number.isRequired,
  endedAtMinutes: PropTypes.number.isRequired,
  extendedHourlyWages: PropTypes.bool.isRequired,
  requirePasscode: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired,
  onRoleChange: PropTypes.func.isRequired,
  passcode: PropTypes.string.isRequired,
  onPasscodeChange: PropTypes.func.isRequired,
  onStartedAtHoursChange: PropTypes.func.isRequired,
  onStartedAtMinutesChange: PropTypes.func.isRequired,
  onEndedAtHoursChange: PropTypes.func.isRequired,
  onEndedAtMinutesChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  shopTime: PropTypes.string.isRequired,
  isSameTimezoneWithUser: PropTypes.bool.isRequired,
  allowedTimeTrackRoles: PropTypes.array.isRequired,
  canEditTimeTracking: PropTypes.bool.isRequired,
};

export default AddTimeTrackingEntry;
